import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component } from "@angular/core";
import { AlertController, NavController, NavParams, Platform/*, Popover, PopoverController*/ } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { Member } from "../../models/interfaces/member.model";
import { PrivilegeRole } from "../../models/interfaces/privilegerole.model";
import { MemberAddPage } from "../../pages/member/member_add";
import { MemberViewPage } from "../../pages/member/member_view";
import { AuthService } from "../../providers/dbservice/authservice";
import { ConfigService } from "../../providers/dbservice/configservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";

@Component({
  selector: "page-member",
  templateUrl: "member.html",
})

export class MemberPage {
  public static readonly MEMBER_ADD_ACCESS = "addMember";
  public static readonly MEMBER_VIEW_ACCESS = "viewMember";
  public static readonly COM_ADD_ACCESS = "addCommittee";
  //private distinctStauts;
  private exportViewName = "vw_export_member";
  private exportFileName = "Member";
  private hasAddMemberAccess: boolean = false;
  private hasAddCommitteeAccess: boolean = false;
  private member$: any;
  private member: Member;
  private member_All = [];
  private distinct_status = [];
  private member_by_status = [];
  private tmpSearchObject_by_status = [];
  private show_status = [];
  private privilegerole$: any;
  private st_id: number;
  private tmpSO;
  private active_st_id: number;
  private memberstatus: string = "Regulars";
  private styleName: string ="";
  // This property will save the callback which we can unsubscribe when we leave this view
  public unsubscribeBackEvent: any;
  constructor(public authService: AuthService, public navCtrl: NavController, public navParams: NavParams,
    public alertCtrl: AlertController, private db: DbserviceProvider, private configService: ConfigService,
    private platform: Platform,/* public popoverCtrl: PopoverController,*/
  ) {
    console.log("MemberPage constructor");
    this.styleName=this.configService.getConfig("STYLENAME");
    this.st_id = 2;
    if (this.authService.currentUser) {
      this.hasAddMemberAccess = this.db.hasAccess(MemberPage.MEMBER_ADD_ACCESS);
      this.hasAddCommitteeAccess = this.db.hasAccess(MemberPage.COM_ADD_ACCESS);
    }
    let mbrDefaultOrder = this.configService.getConfig("DEFAULT_MEMBER_DISPLAY_ORDER");
   
    this.db.dbCol({
      "action": "select", "mapObject": "vw_member",
      "sqlExtended": " order by st_order, mb_hashname"
    }).subscribe((x) => {
      this.member_All = x;
      this.active_st_id = x[0].st_id;
      this.distinct_status = x.reduce((prev, { st_id, st_name }) =>
        prev.some(x => x.st_id === st_id && x.st_name === st_name) ? prev : [...prev, { st_id, st_name }], [])
      this.distinct_status.push()

      this.distinct_status.push({
        st_id: 99,
        st_name: 'All Members',
      });
      this.tmpSO = x.filter(data => Number(data.st_id) === Number(this.distinct_status[0].st_id));

      this.distinct_status.forEach((element, index, array) => {
        if (index == 0) {
          this.show_status[element.st_id] = true;
        }
        else {
          this.show_status[element.st_id] = false;
        }

        if (element.st_id==99 ){
          this.member_by_status[element.st_id]=this.member_All;

        }else{
          this.member_by_status[element.st_id]=this.member_All.filter(data => data.st_name == element.st_name);
        }
        // The tmp object contains all elements, this is used to reset during search
        this.tmpSearchObject_by_status[element.st_id]=this.member_by_status[element.st_id];
      });
    });

    this.privilegerole$ = this.db.dbCol({ "action": "select", "mapObject": "privilegerole" });

  }

  private toggleStatus(currst: number) {
    console.log("MemberPage toggleStatus");
    this.show_status[currst] = !this.show_status[currst];
  }

  private getMember(currst: number) {
    console.log("MemberPage getMember");

    if (currst == 99) {
      this.tmpSO = this.member_All;
    }
    else {
      this.tmpSO = this.member_All.filter(data => Number(data.st_id) === Number(currst));
    }

    return this.tmpSO;
  }

  private getStatus(currst: number) {
    console.log("MemberPage showStatus");
    this.tmpSO = this.member_All.filter(data => Number(data.st_id) === Number(currst));
    return this.tmpSO;
  }

  private OnExport() {
    console.log("MemberPage OnExport");
  }

  private ionViewWillEnter() {
    console.log("MemberPage ionViewWillEnter");
    this.onInitPage();
  }

  private onInitPage() {
    console.log("MemberPage onInitPage");
  }

  private ngOnDestroy() {
    console.log("MemberPage ngOnDestroy");
    this.member$ = null;
  }

  private addMember() {
    console.log("MemberPage addMember");
    this.navCtrl.push(MemberAddPage);
  }

  private viewMember(member: Member) {
    console.log("MemberPage viewMember");
    this.navCtrl.push(MemberViewPage, {
      "member": member,
    });
  }

  private onClear(searchbar, status ) {
    console.log("MemberPage clear");
    this.member_by_status[status] = this.tmpSearchObject_by_status[status];
  }

  private search(searchbar, status) {
    console.log("MemberPage search");
    let q = searchbar.target.value;

    // reset any pre-filtered values
    this.member_by_status[status] = this.tmpSearchObject_by_status[status];

    if (q.trim() === "") {
      this.member_by_status[status] = this.tmpSearchObject_by_status[status];
      return;
    }

    this.member_by_status[status] = this.member_by_status[status].filter((arrayEl) =>
      (arrayEl.mb_hashname.toLowerCase().indexOf(searchbar.target.value.toLowerCase()) > -1) ||
      (arrayEl.mb_firstname.toLowerCase().indexOf(searchbar.target.value.toLowerCase()) > -1) ||
      (arrayEl.mb_lastname.toLowerCase().indexOf(searchbar.target.value.toLowerCase()) > -1) ||
      (arrayEl.mb_birthdate.toLowerCase().indexOf(searchbar.target.value.toLowerCase()) > -1) ||
      (arrayEl.st_name.toLowerCase().indexOf(searchbar.target.value.toLowerCase()) > -1),
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/member/member.ts